/**
 * Organization horizontal-nav items. Departments (idea-MDP-440), Categories
 * (idea-MDP-566) and Job Families (idea-MDP-581) are omitted unless their flags
 * are on.
 *
 * Each item's `label` is the visible menu text while `key` is the stable tab
 * identifier used for routing/state. They differ for the Job Families tab
 * (visible label "Families", identifier still "Job Families" to keep the
 * job-families slug and currentTab wiring unchanged).
 */
export { findOrganizationTab, organizationTabSlug } from "@components/webmcp/navigation/routeConstants";

export function getOrganizationValidTabs({
  ideaMdp440Enabled = false,
  ideaMdp566Enabled = false,
  ideaMdp581Enabled = false,
  readinessProductEnabled = true,
} = {}) {
  const tabs = ["Dashboard", "Employees", "Positions"];
  if (readinessProductEnabled) {
    tabs.push("Roles", "Responsibilities");
  }
  if (ideaMdp440Enabled) {
    tabs.push("Departments");
  }
  if (ideaMdp566Enabled) {
    tabs.push("Categories");
  }
  if (ideaMdp581Enabled) {
    tabs.push("Job Families");
  }
  return tabs;
}

export function buildOrganizationMenuItems({
  ideaMdp440Enabled = false,
  ideaMdp566Enabled = false,
  ideaMdp581Enabled = false,
  readinessProductEnabled = true,
  icons = {},
} = {}) {
  const items = [
    { label: "Dashboard", icon: icons.home },
    { label: "Employees", icon: icons.employee },
    { label: "Positions", icon: icons.position },
  ];
  if (readinessProductEnabled) {
    items.push(
      { label: "Roles", icon: icons.role },
      { label: "Responsibilities", icon: icons.responsibility }
    );
  }
  if (ideaMdp440Enabled) {
    items.push({ label: "Departments", icon: icons.department });
  }
  if (ideaMdp566Enabled) {
    items.push({ label: "Categories", icon: icons.category });
  }
  if (ideaMdp581Enabled) {
    items.push({ label: "Families", key: "Job Families", icon: icons.jobFamily });
  }
  return items;
}
